import { Modal, Typography } from 'antd';
import CloseIcon from '@mui/icons-material/Close';
import CreateCatalogStepper from '../CreateCatalogStepper';

const NewCatalogModal = ({ isEditMode, modalState, handleCloseModal, stepperKey, currentStep, setCurrentStep, draftFormData, setDraftFormData, handleShowSuccessModal, currentDraftId }) => {
    return (
        <Modal
            title={
                <Typography.Title level={4} style={{ marginBottom: '1rem' }}>
                    {isEditMode ? 'Edit Catalogue' : 'Add New Catalogue'}
                </Typography.Title>
            }
            open={modalState === 'main'}
            onCancel={handleCloseModal}
            width="85vw"
            centered
            maskClosable={false}
            footer={null}
            destroyOnHidden={true}
            closeIcon={
                <div
                    className="modal-close-button"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '40px',
                        height: '40px',
                        borderRadius: '6px',
                        transition: 'all 0.2s ease',
                        cursor: 'pointer',
                        backgroundColor: 'transparent',
                        // Assicura che l'area cliccabile sia ben definita
                        padding: '8px',
                    }}
                    onClick={handleCloseModal}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                >
                    <CloseIcon
                        style={{
                            fontSize: '24px',
                            color: '#666',
                            margin: 0,
                            // Assicura che l'icona non interferisca con il click
                            pointerEvents: 'none'
                        }}
                    />
                </div>
            }
        >
            <CreateCatalogStepper
                key={stepperKey}
                onCancel={handleCloseModal}
                onFinish={(formData, catalogueId, isUpdate = false) => {
                    if (isUpdate) {
                        // For updates, close modal without showing success message
                        handleCloseModal();
                    } else {
                        // For new catalogues, show the success modal
                        handleShowSuccessModal(formData, catalogueId);
                    }
                }}
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                onFormDataChange={setDraftFormData}
                initialFormData={draftFormData}
                isEditMode={isEditMode}
                originalCatalogueId={draftFormData?.originalCatalogueId || null}
                currentDraftId={currentDraftId}
            />
        </Modal>
    )
}

export default NewCatalogModal;